type ModuleCardProps = {
  title: string;
  children: React.ReactNode;
  syncButton?: React.ReactNode;
};

const ModuleCard = ({ title, children, syncButton }: ModuleCardProps) => (
  <div className="module-card">
      <h2 className="h4 module-card__title">{title}</h2>
      {syncButton}
    <div className="module-card__content container-style">{children}</div>
  </div>
);

export default ModuleCard;
